export const departmentTranslation = {
  fi: {
    Department: {
      id: '#',
      name: 'Nimi',
    },
  },
};
